var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('iframe',{ref:"iframeDom",attrs:{"name":"GIS","frameborder":"0","width":"100%","height":"100%","src":"http://47.99.177.252:5505/3D/public/level/kj_new.html"}})])}
var staticRenderFns = []

export { render, staticRenderFns }